import { Outlet } from "react-router";

import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const RefundOrgLayout = () => {
    const navList = useNav();
    let { refundOrgBottomNav, topRefundNav } = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={refundOrgBottomNav} topTabs={topRefundNav} />
            <Outlet />
        </div>
    );
}

export default RefundOrgLayout;

